export function getValue<T, R = unknown>(source: T, key: string | string[]) {
  if (!source) {
    return undefined;
  }

  const keys = getKeys(key);
  let parent: Record<string, unknown> = source;
  for (let i = 0; i < keys.length - 1; i++) {
    parent = parent[keys[i]] as Record<string, unknown>;
    if (!parent) {
      break;
    }
  }

  if (!parent) {
    return undefined;
  }

  return parent[keys[keys.length - 1]] as R;
}

export function getKeys(spec: string | string[]) {
  const keys: string[] = Array.isArray(spec) ? spec : spec.split('.');

  return keys;
}
